import React from 'react';
import clsx from 'clsx';

import { SectionProps } from './Section.types';

export const Section = ({
  type = 'default',
  classNames = [],
  children,
}: SectionProps): JSX.Element => {
  return (
    <div
      className={clsx(
        {
          section: type !== 'none',
          section_l: type === 'large',
          section_xl: type === 'xlarge',
        },
        ...classNames
      )}
    >
      {children}
    </div>
  );
};
